import { createContext, useContext } from 'react';

interface INodeStatesContext {
  setNodeState?: (nodeId: string, updatedState: any) => void;
  getNodeState?: (nodeId: string) => any;
}

export const NodeStatesContext = createContext<INodeStatesContext>({});
export const useNodeStatesContext = () => useContext(NodeStatesContext);
